const SET_FACILITY_SUCCEEDED = "SET_FACILITY_SUCCEEDED"

export { SET_FACILITY_SUCCEEDED }